import { HTTP } from './helpers/http.js'
import qs from 'qs'

export default {
  create(organizationId, data) {
    const url = `/api/v1/organizations/${organizationId}/tags`
    return HTTP.post(url, data)
  },

  getAll(organizationId, options = {}) {
    const params = {
      params: options || {},
      paramsSerializer: function(params) {
        return qs.stringify(params, { arrayFormat: 'brackets' })
      },
    }

    const url = `/api/v1/organizations/${organizationId}/tags`
    return HTTP.get(url, params)
  },

  getById(organizationId, tagId) {
    const url = `/api/v1/organizations/${organizationId}/tags/${tagId}`
    return HTTP.get(url)
  },

  update(organizationId, tagId, data) {
    const url = `/api/v1/organizations/${organizationId}/tags/${tagId}`
    return HTTP.patch(url, data)
  },

  getStreamTags(organizationId, options) {
    const params = {
      params: options || {},
      paramsSerializer: function(params) {
        return qs.stringify(params, { arrayFormat: 'brackets' })
      },
    }

    const url = `/api/v1/stream/${organizationId}/tags/`
    return HTTP.get(url, params)
  },
}
